'use strict';

angular.module('cloudBillingLegacyFrontend').controller('EaTsiDataPrivacyCtrl', [ function () {

}]);
